<div *rxLet="state$ as localState" class="reactions-container flex flex-row flex-start-center gap-3">
  @if (localState.reactions !== null) {
    <reactions-list [liked]="localState.liked" [reactions]="localState.reactions"></reactions-list>
  }
  @if (localState.reactions !== null) {
    <reactions-button
      [contentId]="localState.contentId"
      [contentType]="localState.contentType"
      [liked]="localState.liked"
      (reactionSave)="onReactionClick(localState.contentId, localState.contentType, $event)"
      #reactionsButton
    ></reactions-button>
  }
</div>
